import React from "react";
import $ from "jquery";
import { AxiosResponse } from "axios";

import ContentBoxTabTable from "../../../intelws_portal/bundles/ContentBoxTabTable";
import Loading from "../../../intelws_portal/constructs/elements/Loading";
import { IDataRepr} from "../../../intelws_portal/constructs/elements/Table";
import AddButton from "../../../intelws_portal/constructs/elements/AddButton";
import { get, getCancelToken, post } from "../../../intelws_portal/utils/backendInterface";

import * as urls from '../../Urls';

import { IPageComponentProps } from "../../../declarations/common";
import { getBundledAlertsUI } from "../../../declarations/common_utils";
import ModalLeadAdd from "../modal/ModalLeadAdd";
import ModalLead from "../modal/ModalLead";
import ModalLeadNotes from "../modal/ModalLeadNotes";
import { computeFallbackHeaderFormat, EventClickArg, EventContentArg } from "@fullcalendar/common";
import { cloneDeep, first } from "lodash";
import { confirm } from "../../../intelws_portal/constructs/elements/WindowConfirm";
import ContentBoxTable from "../../../intelws_portal/bundles/ContentBoxTable";
import Tabs from "../../../intelws_portal/constructs/elements/Tabs";

import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';
import { cA } from "@fullcalendar/core/internal-common";
import ModalLeadFollowUpInfo from "../modal/ModalLeadFollowUpInfo";

export interface IFollowUpEvents {
    id: number,
    title: string,
    date_str: string,
    uf_emp_id: number
}

interface IFetchLeads extends AxiosResponse {
    data: {
        data: IDataRepr[],
        column_names: string[],
        access_keys: string[]
    }
}

interface IPostFollowUp extends AxiosResponse {
    data: {
        data: IDataRepr
    }
}

interface IPostTransfer extends AxiosResponse {
    data: {
        data: IDataRepr
    }
}

interface IFetchLeadFollowUpEvents extends AxiosResponse {
    data: {
        data: IFollowUpEvents[]
    }
}

function LeadTracking(props: IPageComponentProps) {
    const ENDPOINT = "/api/leads/";
    const [isLoaded, setIsLoaded] = React.useState(false);
    const [tableData, setTableData] = React.useState<(IDataRepr[] | undefined)>(undefined);
    const [currTab, setCurrTab] = React.useState(0);
    const [columnNames, setColumnNames] = React.useState<string[]>([]);
    const [success, setSuccess] = React.useState<string[]>([]);
    const [fail, setFail] = React.useState<string[]>([]);
    const [accessKeys, setAccessKeys] = React.useState<string[]>([]);

    const [firstName, setFirstName] = React.useState("");
    const [lastName, setLastName] = React.useState("");
    const [email, setEmail] = React.useState("");
    const [phoneNum, setPhoneNum] = React.useState("");
    const [leadId, setLeadId] = React.useState("");
    const [contactWay, setContactWay] = React.useState("");
    const [refMethod, setRefMethod] = React.useState("");

    const [followUpLeadId, setFollowUpLeadId] = React.useState(-1);

    const [leadFollowUpId, setLeadFollowUpId] = React.useState(-1);

    const [followUpEvents, setFollowUpEvents] = React.useState<IFollowUpEvents[]>([]);

    const calendarRef = React.useRef(null);

    const cancelTokenSource = React.useRef(getCancelToken());

    React.useEffect(() => {
        if (props.mutator != undefined && props.mutator.currentPage != undefined) {
            props.mutator.currentPage("LeadTracking");
        }
        let queryParams = {
            section: "leads_overview",
        }
        const requestResponse = get(ENDPOINT, cancelTokenSource.current.token, queryParams) as Promise<IFetchLeads>;
        requestResponse.then((response) => {
            setTableData(response.data.data);
            setColumnNames(response.data.column_names);
            setAccessKeys(response.data.access_keys);
            setIsLoaded(true);
        })

        queryParams = {
            section: "get_lead_follow_up"
        }

        const followUpEventsResponse = get(ENDPOINT, cancelTokenSource.current.token, queryParams) as Promise<IFetchLeadFollowUpEvents>;
        followUpEventsResponse.then((response) => {
            setFollowUpEvents(response.data.data);
        })


    }, [])

    React.useEffect(() => {
        if (currTab === 1) {
            if (calendarRef.current) {
                setTimeout(() => {
                    (calendarRef.current as any).getApi().updateSize();
                }, 0);
            }
        }
    }, [currTab])

    function modalAddSaveCallbackForEdit(data?: IDataRepr, success?: string[], fail?: string[]) {
        if (data != undefined) {
            setTableData((prevTableData) => {
                if (prevTableData != undefined) {
                    let newTableData = [data, ...prevTableData.filter(e => e.id != data.id)];
                    return newTableData;
                }
            })
        }
        if (success != undefined && fail != undefined) {
            setSuccess(success);
            setFail(fail);
        }
    }

    function modalAddFollowUpSaveCallback(data?: IFollowUpEvents, success?: string[], fail?: string[]) {
        if (data != undefined) {
            setFollowUpEvents((prevFollowUpEvents) => {
                return [...prevFollowUpEvents, data];
            })
        }
        if (success != undefined && fail != undefined) {
            setSuccess(success);
            setFail(fail);
        }
    }

    function modalMarkFollowUp(leadFollowUpId: number, success?: string[], fail?: string[]) {
        setFollowUpEvents((prevFollowUpEvents) => {
            return prevFollowUpEvents.filter(currEvent => currEvent.id !== leadFollowUpId);
        })

        if (success != undefined && fail != undefined) {
            setSuccess(success);
            setFail(fail);
        }
    }

    function modalEditFollowUp(newEvent?: IFollowUpEvents, success?: string[], fail?: string[]) {
        if (newEvent != undefined) {
            setFollowUpEvents((prevFollowUpEvents) => {
                let newFollowUpEvents = [...prevFollowUpEvents];
                let editIndex = prevFollowUpEvents.findIndex(currEvent => currEvent.id === newEvent.id)
                if (editIndex != -1) {
                    newFollowUpEvents[editIndex] = newEvent;
                }
                return newFollowUpEvents;
            })
        }
    }

    function clearModal(){
        setFirstName("")
        setLastName("")
        setEmail("")
        setPhoneNum("")
        setLeadId("")
        setContactWay("")
        setRefMethod("")
    }

    function leadTableInputCallback(index: number, accessKey: string, value?: boolean | string | HTMLCollectionOf<HTMLOptionElement>) {
        if (accessKey == "user_lead_status" && typeof value == "string") {
            let formData = new FormData(); 
            if (tableData != undefined) {
                formData.append("lead_id", tableData[index].id.toString());
            }
            formData.append("lead_status_id", value);
            let queryParams = {
                section: "set_lead_status"
            }
            const requestResponse = post(ENDPOINT, formData, cancelTokenSource.current.token, queryParams);
            requestResponse.then(() => {
                setTableData((prevTableData) => {
                    if (prevTableData != undefined) {
                        let newTableData = cloneDeep(prevTableData);
                        newTableData = newTableData.map((ele, currIndex) => {
                            if (currIndex == index) {
                                let returnElement = {...ele};
                                (returnElement["user_lead_status"] as any)["value"] = parseInt(value);
                                return returnElement;
                            }
                            return ele;
                        })
                        return newTableData;
                    }
                })
            })
        }

        if (accessKey == "user_lead_service" && typeof value == "string") {
            let formData = new FormData(); 
            if (tableData != undefined) {
                formData.append("lead_id", tableData[index].id.toString());
            }
            formData.append("lead_service_id", value);
            let queryParams = {
                section: "set_lead_service"
            }
            const requestResponse = post(ENDPOINT, formData, cancelTokenSource.current.token, queryParams);
            requestResponse.then(() => {
                setTableData((prevTableData) => {
                    if (prevTableData != undefined) {
                        let newTableData = cloneDeep(prevTableData);
                        newTableData = newTableData.map((ele, currIndex) => {
                            if (currIndex == index) {
                                let returnElement = {...ele};
                                (returnElement["user_lead_service"] as any)["value"] = parseInt(value);
                                return returnElement;
                            }
                            return ele;
                        })
                        return newTableData;
                    }
                })
            })
        }

        if (value == "transfer_lead") {
            let formData = new FormData();
            if (tableData != undefined) {
                formData.append("lead_id", tableData[index].id.toString());
            }
            let queryParams = {
                section: value
            }
            const requestResponse = post(ENDPOINT, formData, cancelTokenSource.current.token, queryParams);
            requestResponse.then((response) => {
                setTableData((prevTableData) => {
                    if (prevTableData != undefined) {
                        let newTableData = cloneDeep(prevTableData);
                        newTableData = newTableData.filter((ele) => ele.id !== newTableData[index].id)
                        return newTableData;
                    }
                })
            })
        } else if (value == "delete_lead") {
            confirm("Are you sure you want to delete this lead?").then(() => {
                let formData = new FormData();
                if (tableData != undefined) {
                    formData.append("lead_id", tableData[index].id.toString());
                }
                let queryParams = {
                    section: value
                }
                const requestResponse = post(ENDPOINT, formData, cancelTokenSource.current.token, queryParams);
                requestResponse.then(() => {
                    setTableData((prevTableData) => {
                        if (prevTableData != undefined) {
                            let newTableData = [...prevTableData];
                            newTableData = newTableData.filter((ele, currIndex) => currIndex !== index);
                            return newTableData;
                        }
                    })
                })
            })
        } else if (value == "follow_up") {
            if (tableData != undefined) {
                setFollowUpLeadId(tableData[index].id);
                $("#leadDueDateModal").modal("show");
            }
        }
    }

    function getLeadTableContent() {
        const miscHeaders = <AddButton buttonValue={<i className="fa fa-plus"></i>}
                onClick={() => { $('#leadAddModal').modal('show'); }} />;

        const link = {
            user_first_name: {
                baseUrl: urls.BASE_COMMON_CLIENT_DASHBOARD,
                urlParams: ['id'], id: ['user_email']
            }
        };


        return (
            <ContentBoxTable miscHeaders={miscHeaders} title="Lead" hasSearch={true} hasRecords={true}
                columnNames={columnNames} accessKeys={accessKeys} tableData={tableData} hasDownload={true} inputCallback={leadTableInputCallback} links={link} />
        )
    }

    function leadFollowUpEventOnClick(eventInfo: EventClickArg) {
        setLeadFollowUpId(eventInfo.event.extendedProps.id as number);
        $("#leadFollowUpInfoModal").modal("show");
    }

    function getLeadFollowUpContent() {
        const renderEventContent = (eventInfo: EventContentArg) => {
            return <>
                <p>{eventInfo.event.title}</p>
            </>
        }

        const dataEvents = followUpEvents.map((eventData) => {
            return {
                title: eventData.title,
                date: eventData.date_str,
                extendedProps: {
                    id: eventData.id
                }
            };
        })
        return (
            <FullCalendar ref={calendarRef} plugins={[dayGridPlugin, timeGridPlugin]} initialView="dayGridMonth"
                headerToolbar={{ left: 'prev,next today', right: 'dayGridMonth,timeGridWeek,timeGridDay' }}
                eventContent={renderEventContent} eventClick={leadFollowUpEventOnClick} events={dataEvents} />
        )
    }

    function getContent() {
        const tabs = [
            {
                target: "leadTable",
                display: "Leads",
                active: true
            },
            {
                target: "leadFollowUpCalendar",
                display: "Follow Up",
                active: false
            }
        ];

        const contents = [
            {
                content: getLeadTableContent()
            },
            {
                content: getLeadFollowUpContent()
            }
        ];

        return <Tabs tabs={tabs} contents={contents} tabCallback={(_, tabIndex) => setCurrTab(tabIndex)} />
    }

    function getAddModal(){
        return (
            <ModalLeadAdd saveCallback={modalAddSaveCallbackForEdit} leadId={leadId} firstName={firstName}
                lastname={lastName} email={email} contact={phoneNum} contactPref={contactWay} contactRef={refMethod} clearModal={clearModal} />
        )
    }
    if (!isLoaded) {
        return <Loading />
    } else {
        return (
            <div className="body-content-wrapper clearfix">
                {getBundledAlertsUI(success, fail, setSuccess, setFail)}
                {getContent()}
                {getAddModal()}
                <ModalLead leadId={followUpLeadId} saveCallback={modalAddFollowUpSaveCallback} clearModal={() => setFollowUpLeadId(-1)} />
                <ModalLeadFollowUpInfo leadFollowUpId={leadFollowUpId} closeModal={() => setLeadFollowUpId(-1)} markAsCompleted={modalMarkFollowUp} editFollowUp={modalEditFollowUp} />
            </div>

        )
    }
}

export default LeadTracking;